/** Styl textového pole k tématu Erma */
export const TextareaStyles = {
  root: {
    background: "var(--erma-secondary-0)",
    disabledBackground: "var(--erma-secondary-40)",
    filledBackground: "var(--erma-primary-0)",
    filledFocusBackground: "var(--erma-primary-50)",
    borderColor: "var(--erma-secondary-220)",
    hoverBorderColor: "var(--erma-secondary-300)",
    focusBorderColor: "var(--erma-primary-400)",
    invalidBorderColor: "#a94442",
    disabledColor: "var(--erma-secondary-700)",
    invalidPlaceholderColor: "var(--erma-red-500)",
    paddingX: "1rem",
    paddingY: "1rem",
    borderRadius: "var(--erma-border-radius-sm)",
    transitionDuration: "1s",
    sm: {
      fontSize: ".9rem",
      paddingX: ".9rem",
      paddingY: ".9rem"
    },
    lg: {
      fontSize: ".8rem",
      paddingX: ".8rem",
      paddingY: ".8rem"
    }
  }
};
